export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "VIP 章节如何解锁？",
    a: "开通会员后，即可根据对应会员等级解锁 VIP 章节。青铜与白银会员按每日免费解锁额度使用，黄金·土豪专属会员可无限解锁全部 VIP 章节，解锁后可在任意设备反复阅读。",
  },
  {
    q: "「无广告阅读」包含哪些内容？",
    a: "成为白银及以上会员后，阅读漫画全程不插入任何横幅广告、弹窗广告或贴片广告，章节翻页流畅无打断，提供纯粹的沉浸式阅读体验。",
  },
  {
    q: "什么是「土豪专属内容抢先看」？",
    a: "部分最新上线的原版韩漫章节会先向黄金会员开放，普通读者稍晚解锁。开通黄金·土豪专属会员即可第一时间抢先看到最新内容，尊享优先阅读权益。",
  },
  {
    q: "漫画画质和原版一致吗？",
    a: "本站提供高画质原版漫画资源，黄金会员可享受 4K 高清画质，画面细节与线条清晰细腻，最大程度还原原版阅读质感。",
  },
  {
    q: "支持哪些设备阅读？",
    a: "网站采用响应式设计，支持电脑、平板与手机访问，适配不同屏幕尺寸。登录同一账号后，阅读进度与已解锁章节会同步到所有设备。",
  },
  {
    q: "会员可以取消或更换套餐吗？",
    a: "可以。您可随时在个人中心查看当前套餐，支持升级或取消续费，取消后已解锁内容在会员有效期内仍可继续阅读，具体规则详见会员服务协议。",
  },
  {
    q: "漫画多久更新一次？",
    a: "热门连载漫画基本保持每日更新，其余作品每周定期更新。开启追更订阅提醒后，作品更新时会第一时间推送通知，不错过任何一话。",
  },
  {
    q: "遇到阅读问题如何联系客服？",
    a: "您可通过页脚或联系板块提交咨询表单，或发送邮件至 support@hanman-tuhao.example.com，客服会在工作时间内尽快回复，为尊享会员提供一对一专属服务。",
  },
];